import { useState } from "react";
import {
  Box,
  Paper,
  TextField,
  Typography,
  Button,
  Alert,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { apiRequest } from "../api/apiClient";

export default function LoginPage() {
  const [email, setEmail] = useState(
    localStorage.getItem("rememberEmail") || "",
  );

  const [password, setPassword] = useState(
    localStorage.getItem("rememberPassword") || "",
  );

  const [remember, setRemember] = useState(
    !!localStorage.getItem("rememberEmail") &&
      !!localStorage.getItem("rememberPassword"),
  );

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    try {
      setLoading(true);
      setError("");

      const res = await apiRequest("/admin/login", {
        method: "POST",
        body: { email, password },
      });

      // Save token
      localStorage.setItem("token", res.token);

      // 🔐 Save email + password if remember checked
      if (remember) {
        localStorage.setItem("rememberEmail", email);
        localStorage.setItem("rememberPassword", password);
      } else {
        localStorage.removeItem("rememberEmail");
        localStorage.removeItem("rememberPassword");
      }

      window.location.href = "/admin";
    } catch (err: any) {
      setError(err?.message || "Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f6f9fc",
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 4,
          width: 360,
          borderRadius: 3,
        }}
      >
        <Typography variant="h5" fontWeight={700} mb={1}>
          Admin Login
        </Typography>

        <Typography variant="body2" color="text.secondary" mb={3}>
          Enter your credentials
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}

        <TextField
          fullWidth
          label="Email"
          size="small"
          margin="normal"
          value={email}
          autoComplete="username"
          onChange={(e) => setEmail(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleLogin()}
        />

        <TextField
          fullWidth
          label="Password"
          type="password"
          size="small"
          margin="normal"
          value={password}
          autoComplete="current-password"
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && handleLogin()}
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={remember}
              onChange={(e) => setRemember(e.target.checked)}
            />
          }
          label="Remember me"
        />

        <Button
          fullWidth
          variant="contained"
          sx={{
            mt: 2,
            py: 1.2,
            fontWeight: 600,
            textTransform: "none",
            borderRadius: 2,
          }}
          onClick={handleLogin}
          disabled={loading}
        >
          {loading ? "Logging in..." : "Login"}
        </Button>
      </Paper>
    </Box>
  );
}
